const storage = {
  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      console.log(`Storage get: ${key}`, item);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error getting from localStorage:', error);
      return null;
    }
  },
  
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      console.log(`Storage set: ${key}`, value);
    } catch (error) {
      console.error('Error setting to localStorage:', error);
    }
  },
  
  remove: (key) => {
    try {
      localStorage.removeItem(key);
      console.log(`Storage remove: ${key}`);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  },
  
  clear: () => {
    try {
      localStorage.clear();
      console.log('Storage cleared');
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }
};

export default storage;